export const TIMEZONES = [
  "UTC",

  // Europe
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Paris",
  "Europe/Berlin",
  "Europe/Madrid",
  "Europe/Rome",
  "Europe/Amsterdam",
  "Europe/Brussels",
  "Europe/Vienna",
  "Europe/Zurich",
  "Europe/Warsaw",
  "Europe/Athens",

  // America
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",

  // Asia
  "Asia/Dubai",
  "Asia/Riyadh",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Tokyo",
];
